import type { LocationDef } from './Location';
import { auroraLakeLocation } from './locations/auroraLake';
import { beachLocation } from './locations/beach';
import { cityLocation } from './locations/city';
import { farmLocation } from './locations/farm';
import { mountainLocation } from './locations/mountain';
import { rooftopLocation } from './locations/rooftop';

export const LOCATIONS: LocationDef[] = [
  auroraLakeLocation,
  cityLocation,
  mountainLocation,
  farmLocation,
  beachLocation,
  rooftopLocation,
];

export function getLocation(id: string): LocationDef | undefined {
  return LOCATIONS.find((l) => l.id === id);
}

/** Draw a stylized thumbnail card for the location select screen. */
export function drawThumbnail(canvas: HTMLCanvasElement, def: LocationDef): void {
  const w = (canvas.width = 240);
  const h = (canvas.height = 110);
  const g = canvas.getContext('2d')!;
  const sky = g.createLinearGradient(0, 0, 0, h * 0.75);
  sky.addColorStop(0, def.thumbnail.skyTop);
  sky.addColorStop(1, def.thumbnail.skyBottom);
  g.fillStyle = sky;
  g.fillRect(0, 0, w, h);
  // Rolling ground band.
  g.fillStyle = def.thumbnail.ground;
  g.beginPath();
  g.moveTo(0, h * 0.72);
  for (let x = 0; x <= w; x += 8) {
    g.lineTo(x, h * 0.72 + Math.sin(x * 0.05 + def.id.length) * 4);
  }
  g.lineTo(w, h);
  g.lineTo(0, h);
  g.fill();
  // Accent stroke: a swoosh of "paint".
  g.strokeStyle = def.thumbnail.accent;
  g.lineWidth = 5;
  g.lineCap = 'round';
  g.beginPath();
  g.moveTo(w * 0.2, h * 0.86);
  g.quadraticCurveTo(w * 0.45, h * 0.68, w * 0.62, h * 0.84);
  g.quadraticCurveTo(w * 0.72, h * 0.93, w * 0.84, h * 0.8);
  g.stroke();
  // A few falling flakes.
  g.fillStyle = 'rgba(255,255,255,0.8)';
  let s = def.id.length * 37 + 11;
  for (let i = 0; i < 26; i++) {
    s = (s * 16807) % 2147483647;
    const x = (s / 2147483647) * w;
    s = (s * 16807) % 2147483647;
    const y = (s / 2147483647) * h * 0.7;
    g.fillRect(x, y, 2, 2);
  }
}
